export default __webpack_public_path__ + "static/media/ticket_sent.713e5292.svg";